module.exports = __webpack_public_path__ + "img/banner_accessories.83a293ae.png";